import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const ROWS = [
  { t: "a single role blueprint", s: "Roles defined once, shared everywhere." },
  { t: "shared competency definitions", s: "Everyone evaluates against the same bar." },
  { t: "consistent evaluation criteria", s: "Structured scorecards across rounds." },
  { t: "structured candidate comparisons", s: "Side-by-side evidence, not opinions." },
];

export function Collaboration({ theme }: { theme: Theme }) {
  return (
    <section style={{ padding: "120px 0", borderTop: `1px solid ${theme.border}` }}>
      <SectionHeader
        theme={theme}
        kicker="Collaboration"
        title="A shared framework for better hiring decisions."
      >
        Rarion creates alignment across hiring managers, recruiters, and stakeholders. Instead of
        fragmented inputs and subjective views, teams work from:
      </SectionHeader>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 40px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 0,
            border: `1px solid ${theme.border}`,
            borderRadius: theme.radius * 1.5,
            overflow: "hidden",
          }}
        >
          {ROWS.map((r, i) => (
            <div
              key={r.t}
              style={{
                padding: 28,
                minHeight: 220,
                borderLeft: i > 0 ? `1px solid ${theme.border}` : "none",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                background: theme.surface,
              }}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 8,
                  background: theme.accentSoft,
                  color: theme.accentFg,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontFamily: theme.mono,
                  fontSize: 13,
                  fontWeight: 500,
                }}
              >
                0{i + 1}
              </div>
              <div>
                <div
                  style={{
                    fontSize: 17,
                    fontWeight: 500,
                    color: theme.fg,
                    letterSpacing: -0.2,
                    marginBottom: 8,
                  }}
                >
                  {r.t}
                </div>
                <div style={{ fontSize: 14, color: theme.fgMute, lineHeight: 1.5 }}>{r.s}</div>
              </div>
            </div>
          ))}
        </div>
        <p
          style={{
            fontSize: 17,
            color: theme.fgMute,
            lineHeight: 1.6,
            maxWidth: 720,
            marginTop: 32,
          }}
        >
          Collaboration becomes more effective because it is structured.
        </p>
      </div>
    </section>
  );
}
